// extracted by mini-css-extract-plugin
export default {"doesNotExist":"_404_doesNotExist__9YER0"};